import { render, staticRenderFns } from "./GrandtotalDays.vue?vue&type=template&id=2ddd72fa&scoped=true"
import script from "./GrandtotalDays.vue?vue&type=script&lang=js"
export * from "./GrandtotalDays.vue?vue&type=script&lang=js"
import style0 from "./GrandtotalDays.vue?vue&type=style&index=0&id=2ddd72fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd72fa",
  null
  
)

export default component.exports